import React, { Component } from 'react';
import './CartIconStyleDropdown.css';

class CartIconStyleDropdown extends Component {

    render = () => (
        <div
            className="cart-icon-dropdown"
        >
            <Icons {...this.props} />
        </div>
    )
}

export default CartIconStyleDropdown;

const getCartIconSamplePath = (folder, cartIconStyle, iconStyle = 'solid') => (`./img/icons/${folder}/${cartIconStyle}_${iconStyle}.svg`)

const Icons = ({ currentIconStyle, currentCartIconStyle, onIconStyleSelect, folder, iconArray }) => (

    <div className="cart-icon-dropdown-header">
          {iconArray.map(item => {
            const isActive = item === currentCartIconStyle;
            let liClassName = 'cart-icon-dropdown-content-item';
            if (isActive) {
              liClassName = 'cart-icon-dropdown-content-active';
            }
            let imgClassName = 'cart-icon-dropdown-content-item__icon';
            if (isActive) {
              imgClassName = 'cart-icon-dropdown-content-item__active cart-icon-dropdown-content-item__icon';
            }
            const iconPath = getCartIconSamplePath(folder, item, currentIconStyle);
            
            return (
              <div key={item}>
                <li
                    onClick={() => onIconStyleSelect(item)}
                    className={liClassName}
                >
                    <img className={imgClassName} src={iconPath} alt="" />
                </li>
              </div>
            );
          })}
    </div>
);
